export default "data:text/csv;base64,77u/c2t1O3F0eTtkZWxpdmVyeURhdGUNCjAxMTU4LTQwMTIwLTczMDsxOzIwMjQtMDEtMDENCjAxMTU4LTQwMTIwLTczMDsyOzIwMjQtMDItMDE="